import gql from 'graphql-tag';

export const GET_GOOGLE_CALENDAR_EVENTS = gql`
  query GetGoogleCalendarEvents(
    $calendarId: String!
    $startTimeMin: DateTime
    $startTimeMax: DateTime
    $limit: Int
    $cursor: String
  ) {
    currentUser {
      id
      googleCalendarEvents(
        calendarId: $calendarId
        limit: $limit
        startTimeMin: $startTimeMin
        startTimeMax: $startTimeMax
        cursor: $cursor
      ) {
        events {
          id
          summary
          description
          creator
          startTime
        }
        nextCursor
      }
    }
  }
`;
